export const API_BASE_URL = 'https://api.oujat.com'
//export const API_BASE_URL = 'http://192.168.29.124:5000'
export const MEDIA_URL = 'https://oujat-storage.s3.us-east-2.amazonaws.com'

export const ApiEndpoints = {
  Content: {
    list: type => `${API_BASE_URL}/api/v1/misc/legalcontent/${type}`
  },
  AUTH: {
    login: `${API_BASE_URL}/api/v1/auth/login/customer`
  },
  SERVICE: {
    list: `${API_BASE_URL}/api/v1/misc/services`,
    listbyid: (id) => `${API_BASE_URL}/api/v1/misc/services/${id}`,
  },
  AGENT: {
    list: `${API_BASE_URL}/api/v1/misc/user/agent`
  },
  QMS: {
    list: `${API_BASE_URL}/api/v1/misc/qms`
  },
  BLOGS: {
    list: `${API_BASE_URL}/api/v1/misc/blogs`,
    details: (blogId) => `${API_BASE_URL}/api/v1/misc/blogs/${blogId}`
  },
  CATEGORIES: {
    list: (type) => `${API_BASE_URL}/api/v1/misc/category/${type}`,
  },
  COUNT: {
    list: (type) => `${API_BASE_URL}/api/v1/misc/services/counts/${type}`,
  },
  CATEGORIES_SERVICE: {
    list: (category) => `${API_BASE_URL}/api/v1/misc/services?category=${category}`,
  },
  HELP: {
    list: `${API_BASE_URL}/api/v1/misc/faqs`,
    details: (faqId) => `${API_BASE_URL}/api/v1/misc/faqs/${faqId}`
  },
  CATEGORY: {
    list: type => `${API_BASE_URL}/api/v1/misc/category/${type}`,
  },
  CAREER: {
    list: `${API_BASE_URL}/api/v1/misc/careers`,
    details: (careerId) => `${API_BASE_URL}/api/v1/misc/careers/${careerId}`,
    addjob: `${API_BASE_URL}/api/v1/misc/job/application`
  },
  WORLDWIDE_DIRECTORY: {
    list: `${API_BASE_URL}/api/v1/misc/agent/count`,
    stateList: `${API_BASE_URL}/api/v1/misc/agent/count/state`,
    details: `${API_BASE_URL}/api/v1/misc/company/directory`
  }
}

